import { Account } from '@modules-deprecated/app/accounts/types'

export const getDisplayTitle = (account: Account) =>
  `${account.accountNo ? account.accountNo + ' - ' : ''}${account.name}`
